"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  en: {
    free: 'Free'
  },
  es: {
    free: 'Gratis'
  },
  fr: {
    free: 'Gratuit'
  },
  de: {
    free: 'Kostenlos'
  }
};